module.exports = __webpack_public_path__ + "img/img-3.26cbc387.png";